import React from 'react';
import { motion } from 'framer-motion';
import { imageVariants, textVariants, containerVariants, corporateContainerVariants } from '../../script/animationVariants'; // Animasyon varyantlarını içe aktarıyoruz

const BizdenHaberler = () => {

    const sektorelitemlerData = [
        {
            imgSrc: '/images/blog-haberler/sektorel-haberler/1.jpg',
            day: '19',
            month: 'EYLÜL',
            title: '8.ADDİS ABABA YAPI VE YAPI MALZEMELERİ FUARI',
            details: '3-16 EKİM 201 ADDİS ABABA / ETİYOPYA',
        },
        {
            imgSrc: '/images/blog-haberler/sektorel-haberler/1.jpg',
            day: '20',
            month: 'EKİM',
            title: 'İSTANBUL YAPI FUARI 2023',
            details: '12-15 EKİM 2023 İSTANBUL / TÜRKİYE',
        },
        {
            imgSrc: '/images/blog-haberler/sektorel-haberler/1.jpg',
            day: '5',
            month: 'KASIM',
            title: 'DUBAİ YAPI VE İNŞAAT FUARI',
            details: '1-5 KASIM 2023 DUBAİ / BAE',
        },
        {
            imgSrc: '/images/blog-haberler/sektorel-haberler/1.jpg',
            day: '5',
            month: 'KASIM',
            title: 'DUBAİ YAPI VE İNŞAAT FUARI',
            details: '1-5 KASIM 2023 DUBAİ / BAE',
        },
    ];

    return (
        <
        >
            {sektorelitemlerData.map((item, index) => (
                <motion.div key={index} className='' variants={corporateContainerVariants}>
                    <motion.div className='aspect-video relative' variants={imageVariants}>
                        <motion.img 
                            src={item.imgSrc} 
                            className='aspect-video w-full h-full' 
                            alt={item.title} 
                            variants={imageVariants} // Görsel animasyonu
                        />
                        <div className='absolute top-0 left-0 aspect-square h-24 bg-white flex flex-col items-center justify-center'>
                            <motion.h4 className='font-bold text-30' variants={textVariants}>{item.day}</motion.h4> {/* Gün animasyonu */}
                            <motion.h4 className='font-light text-30' variants={textVariants}>{item.month}</motion.h4> {/* Ay animasyonu */}
                        </div>
                    </motion.div>

                    <motion.div className='w-full bg-white grid grid-cols-2 py-5' variants={textVariants}>
                        <div className='text-14 text-customGray'>
                            <h6>{item.title}</h6>
                            <h6>{item.details}</h6>
                        </div>
                        <div className='h-10 w-full flex justify-end'>
                            <div className='h-10 w-10 flex justify-center items-center relative'>
                                <div className='h-px absolute w-full bg-customGray'></div>
                                <div className='h-px absolute w-full bg-customGray rotate-90'></div>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            ))}
        </>
    );
}

export default BizdenHaberler;
